import type { IModule } from 'angular'

import angular from './angular-vendor'

export let app: IModule

export function createApp(dependencies: string[]): IModule {
  app = angular.module('post365App', dependencies)

  return app
}

export { angular }
